// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"4907c23e","94":"a6279cd4","513":"cd7ef9d1","557":"6ae9e88a","709":"89c33011","754":"efd8c48e","784":"07c733b7","834":"6415993a","889":"2263c78c"}[chunkId] + ".chunk.js";
};